// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3_b2q","dragIcon":"Choice_dragIcon__iuvKU","left":"Choice_left__1XB43","input":"Choice_input__2jXoY"};